import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [
    'notProspectiveFields',
    'prospectiveRadio',
    'notProspectiveRadio'
  ];

  connect() {
    this.sync();
  }

  // Keep radio + hidden fields synced
  sync() {
    const selected = this.element.querySelector(
      'input[name*="[was_prospective]"]:checked'
    );
    const val = (selected?.value ?? '').toLowerCase();
    const isNo = val === '0' || val === 'false';

    if (isNo) {
      this.notProspectiveStoppage();
    } else {
      this.prospectiveStoppage();
    }
  }

  // Radio actions from the template
  prospectiveStoppage() {
    this.notProspectiveFieldsTarget.classList.add('hide');
  }

  notProspectiveStoppage() {
    this.notProspectiveFieldsTarget.classList.remove('hide');
  }
}
